export class Base {
	// * different usage have different key
	// for usage "type"
	// use key : "name", "typeval"
	// for usage "status"
	// use key : "id", "name"
	protected data;

	public getDataArrays() {
		return this.data;
	}

	// * function for get data search "type"
	public getValue(name: string) {
		let result = this._throwErrorNotFound();

  	this.data.map((value, index) => {
  		if (value.name == name.toLowerCase()) {
  			result = value.typeVal;
  		}
  	});

  	return result;
	}

	public getString(typeVal: number) {
		let result = this._throwErrorNotFound();
		
		this.data.map((value, index) => {
			if (value.typeVal == typeVal) {
				result = value.name;
			}
		});

		return result;
	}
	// ------------ END "TYPE" -----------------

	public _throwErrorNotFound() {
		return new Error('Not Found');
	}

	// * function for get data name "status"
	public getStatusName(id: number) {
		let result = "";

		this.data.map((value, index) => {
			if (value.id == id) {
				result = value.name;
			}
		});

		return result;
	}
	// --------------- END "STATUS" ------------
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/base.ts